export enum TaxtypeEnum {
    GST = 'GST',
    VAT = 'VAT',
    TDS = 'TDS'
  }